import { ArrowDown, ArrowUp, LucideIcon } from "lucide-react"

export enum SortOrder {
  Ascending = "asc",
  Descending = "desc",
}

export function getSortOrderIcon(sortOrder: SortOrder): LucideIcon {
  return sortOrder === SortOrder.Ascending ? ArrowUp : ArrowDown
}

export function getSortOrderName(sortOrder: SortOrder) {
  return sortOrder === SortOrder.Ascending ? "Ascending" : "Descending"
}

export function flipDirection(sortOrder: SortOrder) {
  return sortOrder === SortOrder.Ascending
    ? SortOrder.Descending
    : SortOrder.Ascending
}

export interface SortT<T> {
  value: T
  order: SortOrder
}

export function getSortDisplayT<T>(
  sort: SortT<T>,
  valueExtractor: (item: T) => string,
  keyExtractor: (item: T) => string
): SortDisplayT {
  return {
    label: valueExtractor(sort.value),
    key: keyExtractor(sort.value),
    order: sort.order,
  }
}

export interface SortDisplayT {
  label: string
  key: string
  order: SortOrder
}
